import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import MiscChargeFormComponent from "./component";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useNavigate, useLocation } from "react-router-dom";

const AddMiscellaneousChargeContainer = ({ getDataFromAPI }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const stateData = location.state || {};
    const [partnerName] = useState(stateData.partnerName || "");
    const [loading, setLoading] = useState(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
const [formData, setFormData] = useState({
  franchiseeId: stateData.franchiseeId || "",
  chargeName: "",
  description: "",
  type: "",
  amount: "",
  chargeType: "",
  effectiveDate: "",  // 👈 initially blank
});


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleConfirmSubmit = async () => {
        setShowConfirmationDialog(false);
        
        // 🔹 Basic validations
        if (!formData.chargeName.trim()) {
            toast.error("Charge Name is required");
            return;
        }

        if (!formData.chargeType) {
            toast.error("Please select Charge Type (Credit/Debit)");
            return;
        }

        if (!formData.amount) {
            toast.error("Amount is required");
            return;
        }

        // 🔹 Amount validations
        const amountRegex = /^[0-9]{1,6}$/; 
        if (!amountRegex.test(formData.amount)) {
            toast.error("Enter a valid amount (max 6 digits, numbers only)");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                franchiseeId: parseInt(formData.franchiseeId),
                chargeName: formData.chargeName.trim(),
                description: formData.description.trim(),
                type: formData.type,
                amount: parseInt(formData.amount),
                chargeType: formData.chargeType,
                effectiveDate: formData.effectiveDate,
            };

            await new Promise((resolve, reject) => {
                getDataFromAPI(
                    "/partner/api/v3/acc/misc/charge",
                    "POST",
                    payload,
                    (response) => {
                        toast.success("Charge created successfully!");
                        navigate(-1);
                        resolve(response);
                    },
                    (error) => {
                        toast.error(error.message || "Failed to create charge");
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error("Error:", error);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <MiscChargeFormComponent
            formData={formData}
            handleChange={handleChange}
            handleSubmit={(e) => {
                e.preventDefault();
                setShowConfirmationDialog(true);
            }}
            loading={loading}
            navigate={navigate}
            partnerName={partnerName}
            setFormData={setFormData}
            showConfirmationDialog={showConfirmationDialog}
            setShowConfirmationDialog={setShowConfirmationDialog}
            handleConfirmSubmit={handleConfirmSubmit}
        />
    );
};

export default connect(null, { getDataFromAPI })(AddMiscellaneousChargeContainer);